const QUALITY_ROLES = ["Admin", "Quality Manager", "Quality Staff"];

const isQuality = (role) => QUALITY_ROLES.includes(role);

export const INCIDENT_FLOW = {

  Part1: {
    show: () => true,

    edit: ({ role, status }) =>
      Boolean(role) && (!status || status === "Draft"),
  },

  ImmediateAction: {
    show: ({ status, role }) =>
      (isQuality(role) || role === "Staff" || role === "Supervisor/HOD") &&
      [
        "OVR Submitted",
        "Sent for User Comment",
        "User Comment Received",
        "Investigation Completed",
        "Sent for HOD Review",
        "HOD Comment Submitted",
        "Final Review",
        "Closed"
      ].includes(status),

    edit: ({ role, status }) =>
      isQuality(role) && status === "OVR Submitted",
  },

  UserComment: {
    show: ({ status }) =>
      [
        "Sent for User Comment",
        "User Comment Received",
        "Investigation Completed",
        "Sent for HOD Review",
        "HOD Comment Submitted",
        "Final Review",
        "Closed"
      ].includes(status),

    edit: ({ role, status }) =>
      role === "Staff" && status === "Sent for User Comment",
  },

  HODSelection: {
    show: ({ status, role }) =>
      isQuality(role) &&
      [
        "Investigation Completed",
        "Sent for HOD Review",
        "HOD Comment Submitted",
        "Final Review",
        "Closed"
      ].includes(status),

    edit: ({ role, status }) =>
      isQuality(role) && status === "Investigation Completed",
  },

  HODDetails: {
    show: ({ status }) =>
      [
        "Sent for HOD Review",
        "HOD Comment Submitted",
        "Final Review",
        "Closed"
      ].includes(status),

    edit: ({ role, status }) =>
      (role === "Supervisor/HOD" && status === "Sent for HOD Review") ||
      (["Admin", "Quality Manager"].includes(role) &&
        ["HOD Comment Submitted", "Final Review", "Closed"].includes(status)),
  },

  ActionPlan: {
    show: ({ status, role }) =>
      isQuality(role) &&
      [
        "HOD Comment Submitted",
        "Final Review",
        "Closed"
      ].includes(status),

    edit: ({ role, status }) =>
      (isQuality(role) && status === "HOD Comment Submitted") ||
      (["Admin", "Quality Manager"].includes(role) &&
        ["Final Review", "Closed"].includes(status)),
  },

  Close: {
    show: ({ status, role }) => isQuality(role) && status === "Final Review",
    edit: ({ role }) =>
      isQuality(role),
  }

};
